import * as Sentry from "@sentry/gatsby"

Sentry.init({
  defaultIntegrations: false,
  sendDefaultPii: false,
  dsn: "https://a97a24027ed64289698c69e96053c297@o4511134838554624.ingest.de.sentry.io/4511134851924048",
})
